export default "__VITE_ASSET__DYW0oO5Q__"